@if (raceDaysTableLoaded) {
  <div class="flex justify-center">
    <div class="inline-block shadow-2xl rounded-lg overflow-hidden">
      <p-table
        [value]="raceDaysTable"
        [paginator]="false"
        [responsiveLayout]="'scroll'"
        [size]="'small'"
        >
        <ng-template pTemplate="header">
          <tr>
            <th colspan="4" class="table-header" style="text-align: center;">
              Rennkalender - {{ seasonName || 'Season ' + season_id }}
              @if (plan?.note; as note) {
                <div class="table-subheader">{{ note }}</div>
              }
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [ngClass]="getRowClass(row)">
            <td style="width: 2rem; text-align: center;">
              @if (row.badge) {
                {{ row.badge }}
              } @else {
                <i [class]="row.badge_icon"></i>
              }
            </td>
            <td style="width: 3rem; text-align: center;">
              @if (row.circuit_icon_small) {
                <img src="flag_placeholder.png" [class]="'flag flag-' + row.circuit_icon_small + ' mr-4'" width="30" />
              } @else {
                <i [class]="(row.type_icon || '') + ' type-icon'"></i>
              }
            </td>
            <td><span [class.open-round]="row.circuit_open">{{ row.title }}</span><br /><span [class.day-planned-togo]="!row.done" [class.day-planned-done]="row.done">{{ row.day | date: 'dd.MM.yyyy' }}</span></td>
            <td>@if (row.info1) {
              <span [class.entry-info]="row.entry_type === 'qualification' || row.entry_type === 'event'">{{ row.info1 }}</span>
            }@if (row.info2) {
              <br />
            }{{ row.info2 }}@if (row.group_label) {
              @if (row.info1 || row.info2) {
                <br />
              }
              <span class="group-label">{{ row.group_label }}</span>
            }</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="empty-note">Der Rennkalender wird noch geplant.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
}
@if (!raceDaysTableLoaded) {
  <p>Loading race days...</p>
}
